import React from 'react';
import { useTheme } from 'emotion-theming';
import { Box, Flex } from '@qga/roo-ui/components';
import PulsingLoadingBlock from 'components/PulsingLoadingBlock';
import SkeletonCard from 'components/SkeletonCard';

const PropertyCardSkeleton = React.memo(() => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const theme: any = useTheme();

  return (
    <SkeletonCard height={190} mb={4} p={0}>
      <Flex height="100%">
        <Box>
          <PulsingLoadingBlock {...theme.imageSizes.mapSearchResult} borderRadius={0} />
        </Box>

        <Flex alignItems="space-between" flexDirection="column" pt={4} px={2} width="100%">
          <Box>
            <PulsingLoadingBlock height={18} width={140} />
            <PulsingLoadingBlock height={12} mt={4} width={160} />
          </Box>
          <Flex flexDirection="column" alignItems="flex-end" width="100%">
            <PulsingLoadingBlock height={14} width={90} />
            <PulsingLoadingBlock height={48} width={70} />
            <PulsingLoadingBlock height={18} width={140} />
          </Flex>
        </Flex>
      </Flex>
    </SkeletonCard>
  );
});

PropertyCardSkeleton.displayName = 'PropertyCardSkeleton';

export default PropertyCardSkeleton;
